import React from 'react';
import { Container } from '../../../../components/Container';
import { Typography } from '../../../../components/Typography';
import { WaveBackground } from '../../../../components/WaveBackground';
import waveBackground from '../../../../assets/waves/wave-mariner-blue-background-mobile.svg';
import { Grid } from '../../../../wag-react/core-components/grid';
import { Flex } from '../../../../wag-react/next-components/Flex';
const HEALTH_STATS = [{
  stat: '16K+',
  description: 'Pet Parents Subscribed'
}, {
  stat: '$1.3M+',
  description: 'Saved in vet bills'
}, {
  stat: '14K+',
  description: 'Vet Consults'
}];
export const HealthStatsSection = () => <WaveBackground backgroundImage={`url(${waveBackground})`} bg={[null, null, '#4669B2']} height={['160px', null, 'auto']} data-sentry-element="WaveBackground" data-sentry-component="HealthStatsSection" data-sentry-source-file="index.tsx">
    <Container data-sentry-element="Container" data-sentry-source-file="index.tsx">
      <Grid gridTemplateColumns={['repeat(3, min-content)', 'repeat(3, max-content)', 'repeat(3, min-content)']} justifyContent="space-between" width={[1, null, '50%']} py="28px" data-sentry-element="Grid" data-sentry-source-file="index.tsx">
        {HEALTH_STATS.map(({
        stat,
        description
      }) => <Flex key={stat} flex={1} flexDirection="column">
            <Typography color="champagne" fontSize={['32px', null, '48px']} m={0}>
              {stat}
            </Typography>

            <Typography color="white" fontSize={['16px', null, '18px']} m={0}>
              {description}
            </Typography>
          </Flex>)}
      </Grid>
    </Container>
  </WaveBackground>;